import React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';

const messages = defineMessages({
    menuText: {
        id: 'header.menu.menu_text',
        defaultMessage: 'Меню'
    },
    companyNews: {
        id: 'header.menu.company_news',
        defaultMessage: 'Новости компании'
    },
    regulations: {
        id: 'header.menu.regulations',
        defaultMessage: 'Правила'
    },
    responsibleGame: {
        id: 'header.menu.responsible_game',
        defaultMessage: 'Ответственная игра'
    },
    contactInformation: {
        id: 'header.menu.contact_information',
        defaultMessage: 'Контактная информация'
    },
    bettingShop: {
        id: 'header.menu.betting_shop',
        defaultMessage: 'Пункты приема ставок'
    },
    playersBestBets: {
        id: 'header.menu.players_best_bets',
        defaultMessage: 'Лучшие ставки игроков'
    },
    internetBonus: {
        id: 'header.menu.internet_bonus',
        defaultMessage: 'Акции и бонусы'
    },
    privacyPolicy: {
        id: 'header.menu.privacy_policy',
        defaultMessage: 'Политика конфиденциальности'
    }
});

export default class extends React.Component {
    static propTypes = {
        domain: React.PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {showMenu: false};

        this._onDocumentClick = this._onDocumentClick.bind(this);
        this._onShowMenuClick = this._onShowMenuClick.bind(this);
        this._handleItemClick = this._handleItemClick.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.state.showMenu !== nextState.showMenu;
    }

    componentDidUpdate() {
        if (this.state.showMenu) {
            document.addEventListener('click', this._onDocumentClick);
        }
    }

    componentWillUnmount() {
        document.removeEventListener('click', this._onDocumentClick);
    }

    _handleItemClick(link, e) {
        e.preventDefault();

        window.open(link, 'Menu',
            "toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650");
    }

    _onDocumentClick() {
        document.removeEventListener('click', this._onDocumentClick);

        this.setState({
            showMenu: false
        });
    }

    _onShowMenuClick(e) {
        e.preventDefault();

        this.setState({
            showMenu: true
        });
    }

    render() {
        const dropdownCls = 'dropdown' + (this.state.showMenu ? ' shown' : '');

        const {domain, countryCode, user} = this.props;

        const helpDomain = '//help.' + domain;
        const infoDomain = '//info.' + domain;

        const boundCompanyNewsClick = this._handleItemClick.bind(this, infoDomain + '/news');
        const boundRegulationsNewsClick = this._handleItemClick.bind(this, helpDomain);
        const boundResponsibleNewsClick = this._handleItemClick.bind(this, helpDomain + '/responsible');
        const boundContactsNewsClick = this._handleItemClick.bind(this, infoDomain + '/contacts');
        const boundPrivacyClick = this._handleItemClick.bind(this, helpDomain + '/privacy');
        const boundSalepointsNewsClick = this._handleItemClick.bind(this, helpDomain + '/salepoints');
        const boundBestStakesNewsClick = this._handleItemClick.bind(this, infoDomain);
        const boundPromotionsClick = this._handleItemClick.bind(this, infoDomain + '/promotions');

        let showContactMenu = true;

        if ((!user && countryCode === 'KG') || (user !== null && user.get('resourceId') === 1)) {
            showContactMenu = false;
        }

        return (
            <div className='sidebar-toggle pull-left'>
                <a href="#" className="toggle-menu" onClick={this._onShowMenuClick}/>
                <ul className={dropdownCls}>
                    <li className="title">
                        <FormattedMessage {...messages.menuText} />
                    </li>
                    {/* {showContactMenu && <li>
                        <a href={infoDomain + '/news'} className='company-news' onClick={boundCompanyNewsClick} target="_blank">
                            <FormattedMessage {...messages.companyNews} />
                        </a>
                    </li>} */}
                    <li>
                        <a href={helpDomain} className='regulations' onClick={boundRegulationsNewsClick}
                           target="_blank">
                            <FormattedMessage {...messages.regulations} />
                        </a>
                    </li>
                    <li>
                        <a href={helpDomain + '/privacy'} className='responsible-game' onClick={boundPrivacyClick}
                           target="_blank">
                            <FormattedMessage {...messages.privacyPolicy} />
                        </a>
                    </li>
                    {/* <li>
                        <a href={helpDomain + '/responsible'} className='responsible-game'
                           onClick={boundResponsibleNewsClick}
                           target="_blank">
                            <FormattedMessage {...messages.responsibleGame} />
                        </a>
                    </li>
                    {showContactMenu && <li>
                        <a href={infoDomain + '/contacts'} className='contact-information'
                           onClick={boundContactsNewsClick}
                           target="_blank">
                            <FormattedMessage {...messages.contactInformation} />
                        </a>
                    </li>} */}
                    <li>
                        <a href={infoDomain} className='players-best-bets'
                           onClick={boundBestStakesNewsClick}
                           target="_blank">
                            <FormattedMessage {...messages.playersBestBets} />
                        </a>
                    </li>
                    <li>
                        <a href={infoDomain + '/promotions'} className='internet-bonus'
                           onClick={boundPromotionsClick}
                           target="_blank">
                            <FormattedMessage {...messages.internetBonus} />
                        </a>
                    </li>
                </ul>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/header/Menu.jsx